export default "__VITE_ASSET__9b1c05f9__"